/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { PendingActionCounts } from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getPendingActionsCount = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<PendingActionCounts>> => {
    return axios.get(`/api/pending-actions/count`, options);
};

export const getGetPendingActionsCountQueryKey = () => {
    return [`/api/pending-actions/count`] as const;
};

export const getGetPendingActionsCountQueryOptions = <
    TData = Awaited<ReturnType<typeof getPendingActionsCount>>,
    TError = AxiosError<null>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<typeof getPendingActionsCount>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetPendingActionsCountQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getPendingActionsCount>>
    > = ({ signal }) => getPendingActionsCount({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getPendingActionsCount>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPendingActionsCountQueryResult = NonNullable<
    Awaited<ReturnType<typeof getPendingActionsCount>>
>;
export type GetPendingActionsCountQueryError = AxiosError<null>;

export function useGetPendingActionsCount<
    TData = Awaited<ReturnType<typeof getPendingActionsCount>>,
    TError = AxiosError<null>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getPendingActionsCount>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getPendingActionsCount>>,
                    TError,
                    Awaited<ReturnType<typeof getPendingActionsCount>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingActionsCount<
    TData = Awaited<ReturnType<typeof getPendingActionsCount>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getPendingActionsCount>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getPendingActionsCount>>,
                    TError,
                    Awaited<ReturnType<typeof getPendingActionsCount>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingActionsCount<
    TData = Awaited<ReturnType<typeof getPendingActionsCount>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getPendingActionsCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPendingActionsCount<
    TData = Awaited<ReturnType<typeof getPendingActionsCount>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getPendingActionsCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetPendingActionsCountQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPendingActionsCountSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getPendingActionsCount>>,
    TError = AxiosError<null>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getPendingActionsCount>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetPendingActionsCountQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getPendingActionsCount>>
    > = ({ signal }) => getPendingActionsCount({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPendingActionsCount>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPendingActionsCountSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getPendingActionsCount>>
>;
export type GetPendingActionsCountSuspenseQueryError = AxiosError<null>;

export function useGetPendingActionsCountSuspense<
    TData = Awaited<ReturnType<typeof getPendingActionsCount>>,
    TError = AxiosError<null>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getPendingActionsCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingActionsCountSuspense<
    TData = Awaited<ReturnType<typeof getPendingActionsCount>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getPendingActionsCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingActionsCountSuspense<
    TData = Awaited<ReturnType<typeof getPendingActionsCount>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getPendingActionsCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPendingActionsCountSuspense<
    TData = Awaited<ReturnType<typeof getPendingActionsCount>>,
    TError = AxiosError<null>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getPendingActionsCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetPendingActionsCountSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
